import { Subject, filter } from 'rxjs';
const subject = new Subject();
const growls = new Subject();

export const messageService = {
    sendGrowl: (message) => growls.next(message),
    clearGrowls: () => growls.next(),
    getGrowl: () => {
        return growls.asObservable();
    },

    sendMessage: (message) => subject.next(message),
    clearMessages: () => subject.next(),
    getMessage: (options) => {
        return subject.asObservable().pipe(
            filter((message) => {
                var isMatch = true;
                if (options && options.type) {
                    isMatch = message.type == options.type;
                }
                if (options && options.relatedId) {
                    isMatch = isMatch && message.relatedId == options.relatedId;
                }
                if (options && options.id) {
                    isMatch = isMatch && message.id == options.id;
                }
                return isMatch;
            })
        );
    },
};
